


















import { Component, Vue } from "vue-property-decorator";
import { Item } from "@/game/Models/item";
import FakeBrowser from "@/components/FakeBrowser.vue";

@Component({
  components: {
    FakeBrowser
  }
})
export default class Currency extends Vue {
  constructor() {
    super();
    this.watchDevmode();
  }

  get devmode(): number {
    return this.$store.state.devmode;
  }

  get declaraties(): string {
    return this.$store.state.declaraties;
  }

  set declaraties(value: string) {
    this.$store.commit("setDeclaraties", parseFloat(value));
  }

  get afgekeurdeDeclaraties(): string {
    return this.$store.state.afgekeurdeDeclaraties;
  }

  set afgekeurdeDeclaraties(value: string) {
    this.$store.commit("setAfgekeurdeDeclaraties", parseFloat(value));
  }

  public resetState(): void {
    localStorage.clear();
    window.location.reload();
  }

  private watchDevmode() {
    const kode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
    const l = kode.length;
    let pos = 0;
    document.addEventListener("keydown", event => {
      if (event.keyCode === kode[pos++]) {
        if (l === pos) {
          this.unlockDevmode();
          pos = 0;
        }
      } else {
        pos = 0;
      }
    });
  }

  private unlockDevmode() {
    this.$store.commit("toggleDevmode");
  }
}
